import { initializeApp } from 'firebase/app'

const env = (key: string) => (import.meta.env[key] as string || '').trim()

const memoFirebaseConfig = {
  apiKey: env('VITE_MEMO_FIREBASE_API_KEY'),
  authDomain: env('VITE_MEMO_FIREBASE_AUTH_DOMAIN'),
  projectId: env('VITE_MEMO_FIREBASE_PROJECT_ID'),
  storageBucket: env('VITE_MEMO_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('VITE_MEMO_FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('VITE_MEMO_FIREBASE_APP_ID'),
}

// 두 번째 Firebase 앱 인스턴스 (이름: 'memo')
const canInit = !!(memoFirebaseConfig.apiKey && memoFirebaseConfig.projectId && memoFirebaseConfig.authDomain)
export const memoApp = canInit ? initializeApp(memoFirebaseConfig, 'memo') : null

if (canInit) {
  console.info('[Memo] Firebase 앱 초기화 성공:', memoFirebaseConfig.projectId)
} else {
  console.warn('[Memo] Firebase 앱 초기화 실패 — 환경변수 누락:', {
    apiKey: !!memoFirebaseConfig.apiKey,
    projectId: !!memoFirebaseConfig.projectId,
    authDomain: !!memoFirebaseConfig.authDomain,
  })
}

// Lazy-loaded Memo Auth
let _memoAuth: import('firebase/auth').Auth | null = null
export async function getMemoAuthInstance() {
  if (!memoApp) return null
  if (!_memoAuth) {
    const { getAuth } = await import('firebase/auth')
    _memoAuth = getAuth(memoApp)
  }
  return _memoAuth
}

// Lazy-loaded Memo Firestore
let _memoFirestore: import('firebase/firestore').Firestore | null = null
export async function getMemoFirestoreInstance() {
  if (!memoApp) return null
  if (!_memoFirestore) {
    const { getFirestore } = await import('firebase/firestore')
    _memoFirestore = getFirestore(memoApp)
  }
  return _memoFirestore
}
